export const sidemenu = {
  show: "SHOW_SIDE_MENU",
  hide: "HIDE_SIDE_MENU"
}

export const cartItem = {
  add: "ADD_TO_CART",
  del:"DELETE_FROM_CART",
  update:"UPDATE_CART"
}